module.exports = __webpack_public_path__ + "static/img/s3.d413347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/s3.png
// module id = ZmKw
// module chunks = 1